import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type {
  AuditoriaProcessoState,
  FiltrosAuditoriaProcesso,
} from '../../types/auditoriaProcesso';
import { fetchAuditoriaProcesso, fetchFiltrosAuditoriaProcesso } from './actions';

const LIMITE_PADRAO_AUDITORIA = 20;

const initialState: AuditoriaProcessoState = {
  activeRequestId: null,
  activeFiltrosRequestId: null,
  processoArbitralId: null,
  items: [],
  total: 0,
  page: 1,
  limit: LIMITE_PADRAO_AUDITORIA,
  filtros: {},
  usuariosDisponiveis: [],
  isLoading: false,
  isLoadingFiltros: false,
  error: null,
};

const auditoriaProcessoSlice = createSlice({
  name: 'secretariaArbitralAuditoria',
  initialState,
  reducers: {
    setFiltrosAuditoria(state, action: PayloadAction<FiltrosAuditoriaProcesso>) {
      state.filtros = action.payload;
      state.page = 1;
    },
    setPaginaAuditoria(state, action: PayloadAction<number>) {
      state.page = action.payload;
    },
    limparAuditoria() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAuditoriaProcesso.pending, (state, action) => {
        state.error = null;
        state.isLoading = true;
        state.activeRequestId = action.meta.requestId;
        state.processoArbitralId = action.meta.arg.processoArbitralId;
      })
      .addCase(fetchAuditoriaProcesso.fulfilled, (state, action) => {
        if (state.activeRequestId !== action.meta.requestId) return;
        state.activeRequestId = null;
        state.isLoading = false;
        state.items = action.payload.items;
        state.total = action.payload.total;
        state.page = action.payload.page;
        state.limit = action.payload.limit;
      })
      .addCase(fetchAuditoriaProcesso.rejected, (state, action) => {
        if (state.activeRequestId !== action.meta.requestId) return;
        state.activeRequestId = null;
        state.isLoading = false;
        state.error = action.payload ?? 'Erro ao carregar a auditoria do processo';
      })
      .addCase(fetchFiltrosAuditoriaProcesso.pending, (state, action) => {
        state.isLoadingFiltros = true;
        state.activeFiltrosRequestId = action.meta.requestId;
      })
      .addCase(fetchFiltrosAuditoriaProcesso.fulfilled, (state, action) => {
        if (state.activeFiltrosRequestId !== action.meta.requestId) return;
        state.activeFiltrosRequestId = null;
        state.isLoadingFiltros = false;
        state.usuariosDisponiveis = action.payload.usuarios;
      })
      .addCase(fetchFiltrosAuditoriaProcesso.rejected, (state, action) => {
        if (state.activeFiltrosRequestId !== action.meta.requestId) return;
        state.activeFiltrosRequestId = null;
        state.isLoadingFiltros = false;
        state.usuariosDisponiveis = [];
      });
  },
});

export const { setFiltrosAuditoria, setPaginaAuditoria, limparAuditoria } =
  auditoriaProcessoSlice.actions;
export const secretariaArbitralAuditoriaReducer = auditoriaProcessoSlice.reducer;
